module.exports = __webpack_public_path__ + "static/media/ec.e6cc1f96.png";